// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import { useId } from 'react';
import type { Icon } from 'iconsax-react';

/**
 * Solid green circle with a check — the policy "saved/confirmed" indicator
 * used on the advisor wizard's saved-policy cards. Extracted verbatim from
 * the previous inline SVG so the visual is pixel-identical.
 */
const PolicySuccessCircleIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || '#00A63E';
  const id = useId();
  const clipId = `policy-success-clip-${id}`;
  const maskId = `policy-success-mask-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="policy success circle"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <mask id={maskId} style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <path d="M24 0H0V24H24V0Z" fill="white" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" fill={fill} />
          <path d="M10.5799 15.5816C10.3799 15.5816 10.1899 15.5016 10.0499 15.3616L7.21994 12.5316C6.92994 12.2416 6.92994 11.7616 7.21994 11.4716C7.50994 11.1816 7.98994 11.1816 8.27994 11.4716L10.5799 13.7716L15.7199 8.63156C16.0099 8.34156 16.4899 8.34156 16.7799 8.63156C17.0699 8.92156 17.0699 9.40156 16.7799 9.69156L11.1099 15.3616C10.9699 15.5016 10.7799 15.5816 10.5799 15.5816Z" fill={fill} />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { PolicySuccessCircleIcon };
